// Org codes for which the Appointment / Expedite flags make the appointment
// date + time-window mandatory at create/edit. Single source of truth — this
// gate is consumed by AddressLocationDetails, AppointmentWindow, ContextualModal
// and AddressLocationsView; keep it here so the four never drift apart.
export const APPOINTMENT_MANDATORY_ORG_CODES = ["MWE", "FET"];

export const isAppointmentMandatoryOrg = (orgCode) =>
  APPOINTMENT_MANDATORY_ORG_CODES.includes(orgCode);
